import React, { SVGProps } from 'react'
const SvgMissingReceiptsTask = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    aria-hidden="true"
    {...props}
  >
    <rect width="20" height="20" rx="10" fill="black" />
    <path
      d="M6 14.3616V6.25C6 5.69772 6.44772 5.25 7 5.25H13C13.5523 5.25 14 5.69772 14 6.25V14.3616C14 14.797 13.4823 15.0244 13.1617 14.7298L12.3133 13.9504C12.1327 13.7844 11.8584 13.774 11.6657 13.9258L10.3093 14.9939C10.1279 15.1368 9.87213 15.1368 9.69066 14.9939L8.33429 13.9258C8.14159 13.774 7.86728 13.7844 7.68667 13.9504L6.83828 14.7298C6.51771 15.0244 6 14.797 6 14.3616Z"
      stroke="white"
      strokeLinecap="round"
    />
    <path
      d="M7.5 7H11.5M7.5 9.25H11.5M7.5 11.75H10.0714"
      stroke="white"
      strokeWidth="0.8"
      strokeLinecap="round"
    />
  </svg>
)
export default SvgMissingReceiptsTask
